export default "{\n    \"languageSelectPlaceholder\": \"Select preferred language\",\n    \"languageSelectLabel\": \"Language\"\n}\n"